










import {
  CollectionItem,
  CollectionItemType,
} from '@/resource/collection-item/collection-item.model';
import { Component, Prop, Vue } from 'vue-property-decorator';
import QuestionContainer from '@/components/questions/QuestionContainer.vue';

@Component({
  components: {
    QuestionContainer,
  },
})
export default class ItemQuestion extends Vue {
  @Prop({ required: true })
  collectionItem!: CollectionItem;

  get isObjective() {
    return (
      this.collectionItem.collectionItemType === CollectionItemType.Objective
    );
  }

  get question() {
    if (this.isObjective) {
      return this.collectionItem.questionObjective;
    } else {
      return this.collectionItem.questionSubjective;
    }
  }
}
